import { Typography } from "@material-ui/core";
import "./index.scss";
import classcat from "classcat";

export type BadgeType = "novelty" | "processing" | "beta";

const Badge = ({ text, type }: { text: string; type: BadgeType }) => {
  const statusStyle = {
    novelty: "novelty",
    processing: "processing",
    beta: "beta",
  };

  return (
    <div className={classcat(["container", statusStyle[type]])}>
      <Typography className="text">{text}</Typography>
    </div>
  );
};

export default Badge;
